import { DirectorySearch } from "@/components/directory/DirectorySearch";

interface DirectoryFiltersProps {
  categories: { id: string; name: string; }[];
  selectedCategory: string;
  searchTerm: string;
  showOrganizations: boolean;
  onCategoryChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  onToggleView: () => void;
  selectedLookingFor: string[];
  onLookingForChange: (categories: string[]) => void;
  budgetRange: [number, number];
  onBudgetRangeChange: (range: [number, number]) => void;
}

export const DirectoryFilters = ({
  categories,
  selectedCategory,
  searchTerm,
  showOrganizations,
  onCategoryChange,
  onSearchChange,
  onToggleView,
  selectedLookingFor,
  onLookingForChange,
  budgetRange,
  onBudgetRangeChange
}: DirectoryFiltersProps) => {
  return (
    <div className="space-y-6">
      {/* Search Bar Section */}
      <div className="relative flex-1">
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <DirectorySearch
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            selectedCategory={selectedCategory}
            onCategoryChange={onCategoryChange}
            categories={categories}
            showCategoryFilter={true}
            selectedLanguages={[]}
            onLanguagesChange={() => {}}
            selectedExperienceLevel=""
            onExperienceChange={() => {}}
            selectedAvailability=""
            onAvailabilityChange={() => {}}
            selectedLookingFor={selectedLookingFor}
            onLookingForChange={onLookingForChange}
            budgetRange={budgetRange}
            onBudgetRangeChange={onBudgetRangeChange}
          />
        </div>
      </div>
    </div>
  );
};